import { schema } from 'normalizr';
import { MentorshipProgramConnection, MentorshipProgramRequest } from 'redux/schemas/models/mentorship-program-connections';

export const MentorshipProgramConnectionSchema = new schema.Entity<
MentorshipProgramConnection
>('mentorshipProgramConnections');

export const MentorshipProgramRequestSchema = new schema.Entity<
MentorshipProgramRequest
>(
  'mentoringProgramRequests',
);

export const MentorshipProgramConnectionsSchema = new schema.Array(
  MentorshipProgramConnectionSchema,
);

export const MentorshipProgramRequestsSchema = new schema.Array(
  MentorshipProgramRequestSchema,
);
